import React from "react"
import ContentWrapper from "../../components/common/AssessmentContentWrapper.js"
import AdminTemplate from "../../components/admin/layouts/Template.js"
import PropTypes from "prop-types"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import { connect } from "react-redux"
import QuestionCategory from "./question/Category.js"
import ManageCategories from "./question/ManageCategories.js"
import QuestionAuthor from "./question/Author.js"
import ManageAuthors from "./question/ManageAuthors.js"
import QuestionDifficulty from "./question/Difficulty.js"
import QuestionLanguage from "./question/Language.js"
import ManageLanguage from "./question/ManageLanguage.js"
import QuestionSource from "./question/Source.js"
import QuestionSubject from "./question/Subject.js"
import ManageSubject from "./question/ManageSubject.js"
import QuestionTerm from "./question/Term.js"
import ManageTerm from "./question/ManageTerm.js"
import QuestionTypes from "./question/Types.js"
import QuestionYear from "./question/Year.js"
import QuestionChapter from "./question/Chapter.js"
import AssessmentAttempt from "./assessment/Attempt.js"
import AssessmentCategory from "./assessment/Category.js"
import ManageGrade from "./manage/ManageGrade.js";
import ManageSchedule from "./candidate/ManageSchedule.js"
import ManageAttempt from "./candidate/ManageAttempt.js"
import ManagePaperTerms from "./manage/ManagePaperTerms.js"
import ManagePapers from "./manage/ManagePapers.js"
import ManageQuestions from "./manage/ManageQuestions.js"
import ManageExamCategories from "./manage/ManageExamCategories.js";
import ManageGradeScale from "./candidate/ManageGradeScale.js"
import ManageAuthorTypes from "./manage/ManageAuthorTypes.js";
import ManageAssessmentStatus from "./manage/ManageAssessmentStatus.js";

import { Modal } from "react-bootstrap"
import "./Settings.css"
import MenuIcon from "@mui/icons-material/Menu"
import config from '../../helper/config.js';
import {customerConstants} from "../../helper/constants.js";
import ManageGreadeMethod from "./manage/ManageGreadeMethod.js"

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let tabTextColor
const customer = getCustomerFeatureFlag()
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    tabTextColor = "var(--maincolor)"
    break
  case customerConstants.EXO_CUSTOMER2:
    tabTextColor = "var(--maincolor-cmc)"
    break
  default:
    tabTextColor = "var(--maincolor)"
    break
}

class AssessmentSettings extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: 0,
      screenWidth: window.innerWidth,
      isTabSectionVisible: false,
    }

    this.handleResize = this.handleResize.bind(this)
  }

  handleChange = (event, newValue) => {
    this.setState({ value: newValue, isTabSectionVisible: false })
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize)
  }

  handleResize() {
    this.setState({
      screenWidth: window.innerWidth,
    })
  }

  toggleTabSection = () => {
    this.setState((prevState) => ({
      isTabSectionVisible: !prevState.isTabSectionVisible,
    }))
  };

  renderTabs() {
    const employeeType = sessionStorage.getItem("employeeType");
    const commonTabs = [
      { label: "Manage-Question-Category", index: 0 },
      { label: "Manage-Source", index: 1 },
      { label: "Manage-All-Question-Details", index: 2 },
      { label: "Manage-Exam-Category", index: 3 },
      { label: "Manage-Assessment-Attempt", index: 4 },
      { label: "Manage-Medium/Language", index: 5 },
      { label: "Manage-Author", index: 6 },
      { label: "Manage-Difficulty", index: 7 },
      { label: "Manage-Grade", index: 8 },
      { label: "Manage-Subject", index: 9 },
      { label: "Manage-Chapter/Module/Unit", index: 10 },
      { label: "Manage-Term/Semester", index: 11 },
      { label: "Manage-Year", index: 12 },
      { label: "Manage-Student-Paper-Schedule", index: 13 },
      { label: "Manage-Student-Paper-Attempt", index: 14 },
      { label: "Manage-Paper-Terms-and-Conditions", index: 15 },
      { label: "Manage-All-Paper-Details", index: 16 },
      { label: "Manage-Author-Types", index: 17 },
      { label: "Manage-Assessment-Statuses", index: 18 },
      { label: "Manage-Grading-Method", index: 19 },
    ];

    if (employeeType === "DEOP") {
      return commonTabs.slice(0, 1); // DEOP users get only the first tab
    } else {
      return commonTabs; // Other users get all the tabs
    }
  }

  renderTabPanels() {
    const { value } = this.state;
    const panels = [
      <ManageCategories />,
      <QuestionSource />,
      <ManageQuestions />,
      <ManageExamCategories />,
      <AssessmentAttempt />,
      <ManageLanguage />,
      <ManageAuthors />,
      <QuestionDifficulty />,
      <ManageGrade />,
      <ManageSubject />,
      <QuestionChapter />,
      <ManageTerm />,
      <QuestionYear />,
      <ManageSchedule />,
      <ManageAttempt />,
      <ManagePaperTerms />,
      <ManagePapers />,
      <ManageAuthorTypes/>,
      <ManageAssessmentStatus/>,
      <ManageGreadeMethod/>,
    ];

    return panels.map((panel, index) => (
      <TabPanel value={value} index={index} key={index}>
        {panel}
      </TabPanel>
    ));
  }

  render() {
    const { value, screenWidth, isTabSectionVisible } = this.state
    const tabs = this.renderTabs();

    return (
      <AdminTemplate>
        <ContentWrapper>
          <Box
            sx={{
              flexGrow: 1,
              bgcolor: "background.paper",
              display: "flex",
              height: "100%",
            }}
          >
            <div style={{ width: screenWidth < 1246 ? "75px" : "" }}>
              <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={this.handleChange}
                aria-label="Vertical tabs example"
                sx={{
                  borderRight: 1,
                  borderColor: "divider",
                  "& .MuiTab-root": {
                    fontFamily: "Poppins, sans-serif",
                    textTransform: "unset",
                    letterSpacing: "-0.4px",
                    fontWeight: "600",
                    alignItems: "start"
                  },
                  "& .Mui-selected, & .Mui-selected.MuiTab-root": {
                    color: tabTextColor + " !important",
                  },
                }}
                TabIndicatorProps={{
                  style: {
                    backgroundColor: tabTextColor
                  },
                }}
                style={{
                  display: screenWidth < 1246 ? "none" : "",
                }}
              >
                {tabs.map((tab) => (
                  <Tab key={tab.index} label={tab.label} {...a11yProps(tab.index)} />
                ))}
              </Tabs>
            </div>
            <button
              className="settings-menu"
              style={{
                display: screenWidth < 1246 ? "" : "none",
              }}
              onClick={this.toggleTabSection}
            >
              <MenuIcon style={{ marginLeft: "25px", fontSize: "24px" }} />
            </button>

            {this.renderTabPanels()}
          </Box>
        </ContentWrapper>

        {/* Tab Section Modal */}
        <Modal
          size="lg"
          centered
          onHide={() => this.setState({ isTabSectionVisible: false })}
          show={isTabSectionVisible && screenWidth < 1246}
        >
          <Modal.Header
            className="d-flex justify-content-end"
            closeButton
            />
          <Modal.Body>
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={value}
              onChange={this.handleChange}
              aria-label="Vertical tabs example"
              sx={{
                "& .MuiTab-root": {
                  fontFamily: "Poppins, sans-serif",
                  textTransform: "unset",
                  letterSpacing: "-0.4px",
                  fontWeight: "600"
                },
                "& .Mui-selected": {
                  color: tabTextColor
                },
                borderRight: 1,
                borderColor: "divider"
              }}
              TabIndicatorProps={{
                style: {
                  backgroundColor: tabTextColor
                },
              }}
              className="collapsible-tab"
            >
              {tabs.map((tab) => (
                <Tab key={tab.index} label={tab.label} {...a11yProps(tab.index)} />
              ))}
            </Tabs>
          </Modal.Body>
        </Modal>
      </AdminTemplate>
    )
  }
}

function TabPanel(props) {
  const { children, value, index, ...other } = props
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  }
}

export default AssessmentSettings
